<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import { onMounted } from 'vue'
import { isDarkModeActive } from '@/helpers/darkMode.ts'
import BaseModal from '@/components/UI/BaseModal/BaseModal.vue'
import { useI18n } from 'vue-i18n'
import { useErrorStore } from '@/stores/error.ts'
import Button from 'primevue/button'
import { useToast } from 'primevue'
import { registerToast } from '@/services/modules/toastService.ts'
import AppLoader from '@/components/Global/AppLoader/AppLoader.vue'

const { t } = useI18n()
const errorStore = useErrorStore()
const toast = useToast()

registerToast(toast)

const refreshPage = () => {
    window.location.reload()
}
const onUpdateVisible = (isVisible: boolean | undefined) => {
    if (!isVisible) {
        errorStore.clearGlobalError()
    }
}

onMounted(() => {
    if (isDarkModeActive()) {
        document.documentElement.classList.toggle('lets-dark')
    }
})
</script>

<template>
    <AppLoader />
    <RouterView />
    <Toast />
    <BaseModal
        class="global-error-modal"
        :visible="!!errorStore.errorMessage"
        :modal-title="t('Error')"
        @update:visible="onUpdateVisible($event)"
    >
        <template #content>
            <div class="content">
                <p>
                    {{ errorStore.errorMessage }}
                </p>

                <div class="actions">
                    <Button @click="refreshPage" :label="t('Refresh page')" icon="pi pi-sync" />
                    <Button outlined :label="t('Close')" @click="errorStore.clearGlobalError()" />
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: column;
    gap: $space-md;
}

.global-error-modal {
    .actions {
        display: flex;
        flex-direction: column;
        gap: $space-md;
        margin-top: $space-md;
    }

    @include screen(md) {
        .actions {
            flex-direction: row;
            justify-content: flex-end;
        }
    }
}
</style>
